import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User } from '../management/user/user';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private http: HttpClient, private auth: AuthService) { }

  getProfileInformation(): Observable<User> {
    // return this.http.get<User>(`/server/profile/profile.php?action=getUserInformation`)
    return this.http.get<User>(`/api/users/currentUser`)
    .pipe(map(response =>{
      console.log(response)
      return response
    }));
  }

  updateProfileInformation(user: User): Observable<boolean> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const data = `action=updatePersonalInformation&firstName=${user.firstName}&lastName=${user.lastName}&email=${user.email}&phoneNumber=${user.phoneNumber}`
    return this.http.post<UpdateServiceResponse>("/server/profile/profile.php", data, {headers: baseHeaders})
    .pipe(map(response => {
      console.log(response)
      return response.success
    }))
  }
}

interface UpdateServiceResponse {
  success: boolean
}